import { configureStore } from '@reduxjs/toolkit';

import profileReducer from './ProfileSlice';
import availabilityReducer from './AvailabilitySlice';
import bookingReducer from './BookingSlice';
import tokenReducer from './TokenSlice';
import searchReducer from './SearchSlice';
import schoolReducer from './SchoolSlice';
import tempSchoolReducer from './TempSchoolSlice';
import notificationReducer from './NotificationSlice';
import jobsReducer from './JobsSlice';
export default configureStore({
    reducer: {
        profile: profileReducer,
        availability: availabilityReducer,
        booking: bookingReducer,
        token: tokenReducer,
        search: searchReducer,
        school: schoolReducer,
        tempSchool: tempSchoolReducer,
        notification: notificationReducer,
        jobs: jobsReducer,
    },
});
